<div *ngIf="this.myLoading" class="flex items-center justify-center h-screen">
  <p-progressSpinner>
    </p-progressSpinner>
</div>
<div class="px-1 py-2 surface-ground md:px-1 lg:px-2">
    <div>
      <section class="px-6 py-1 surface-section">
        <header
          class="flex w-full p-4 pb-5 m-4 text-primary-500 justify-content-between align-items-center border-bottom-1 surface-border">
          <div>
            <h2 class="mt-0 mb-3 text-2xl font-medium">
              Nice To See You, {{ customer_overview()?.first_name }}!
            </h2>
            <p
              *ngIf="this.hasSubscriptions"
              class="mt-0 mb-0 text-base font-normal text-500">
              Here's an overview of your account.
            </p>
            <div
              *ngIf="
               !this.hasSubscriptions && !this.myLoading
              ">
              <p class="mt-0 mb-0 text-base font-bold text-500">
                Unfortunately, using the email address that you have logged in
                with, we have been unable to locate your account.
              </p>
              <p class="mt-0 mb-0 text-base text-500">
                Please logout, and try login again with the email address used
                with your account, or contact
                <a href="mailto:support@claddedglass.com">
                  support&#64;claddedglass.com
                </a>
                to change the email address associated with this account
              </p>
            </div>
          </div>
        </header>
        <div
          *ngIf="this.hasSubscriptions">
          <app-account-information
            [customer_overview]="this.customer_overview"></app-account-information>
          <app-billing-information
            [customer_overview]="this.customer_overview"></app-billing-information>
          <app-subscription-information
            [customer_overview]="
              this.customer_overview
            "></app-subscription-information>
        </div>
      </section>
    </div>
</div>
